module.exports = __webpack_public_path__ + "img/symphony_898_antracite.8f6c593d.jpg";